import { render } from "./BlockRenderer.vue?vue&type=template&id=78d7e516&scoped=true"
import script from "./BlockRenderer.vue?vue&type=script&lang=js"
export * from "./BlockRenderer.vue?vue&type=script&lang=js"

import "./BlockRenderer.vue?vue&type=style&index=0&id=78d7e516&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d7e516"]])

export default __exports__